/**
 * Tracer Bullet: useStream hook for brainstorm via @launch10/langgraph-server
 *
 * Talks to the standard LangGraph protocol API served by createLangGraphApi
 * on LANGGRAPH_SERVER_PORT (default 4002).
 */
import { useStream } from "@langchain/langgraph-sdk/react";
import { useJwt, useLanggraphPath } from "~/stores/sessionStore";

function getThreadIdFromUrl(): string | undefined {
  // Brainstorm lives at /threads/:thread_id; keep the legacy
  // /projects/:uuid/brainstorm shape as a fallback for in-flight links.
  const threadMatch = window.location.pathname.match(/^\/threads\/([^/]+)$/);
  if (threadMatch) return threadMatch[1];
  const legacy = window.location.pathname.match(/^\/projects\/([^/]+)\/brainstorm$/);
  return legacy?.[1];
}

export function useBrainstormStream(threadId?: string) {
  const jwt = useJwt();
  const langgraphPath = useLanggraphPath();

  const resolvedThreadId = threadId ?? getThreadIdFromUrl();

  return useStream({
    apiUrl: langgraphPath ?? "http://localhost:4000",
    assistantId: "brainstorm",
    threadId: resolvedThreadId,
    defaultHeaders: {
      Authorization: `Bearer ${jwt}`,
    },
  });
}
